// extracted by mini-css-extract-plugin
export default {"modal":"FN-z","modalOverlay":"GN-z","outfitHeading":"HN-z"};